import { Component } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { DownloadableFile } from '../../interfaces/interfaces';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmComponent } from '../confirm/confirm.component';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-customers',
    templateUrl: './files.component.html',
    styleUrls: ['./files.component.scss'],
    providers: [DialogService]
})
export class FilesComponent extends UnsubscribeComponent {

    files: DownloadableFile[] = [];

    constructor(
        private apiService: ApiService,
        private dialogService: DialogService
    ) {
        super();
        this.loadFiles();
    }

    loadFiles(): void {
        this.apiService.loadFiles().subscribe((rsp) => {
            this.files = rsp.files;
        });
    }

    fileChanged(event: Event, file: DownloadableFile): void {
        const input: HTMLInputElement = (event.target as HTMLInputElement);
        if (input.files.length > 0) {
            this.apiService.uploadFile(file.fileName, input.files.item(0)).subscribe(() => {
                this.loadFiles();
            });
        }
    }

    deleteFile(file: DownloadableFile): void {
        this.dialogService.open(ConfirmComponent, {
          data: {
            title: 'File törlése',
            text: 'Biztosan törlöd ezt a filet?',
            acceptText: 'Törlés',
            declineText: 'Mégsem'
          }
        }).onClose.pipe(filter(v => v === true)).subscribe(() => {
            this.apiService.deleteFile(file.fileName).subscribe(() => {
                this.loadFiles();
            });
        });
    }
}
